import React, { useState } from 'react';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { InputAdornment, TextField } from '@mui/material';

import newCalenderImage from '../../assets/icons/new-calender.svg';
import SpinnerLoader from '../../assets/svg/spinnerLoader.svg';
import './DatePicker.scss';

const locale = 'en';

interface MuiDateProps {
  placeHolder?: string;
  value?: string | null;
  required?: boolean;
  label?: string;
  testId?: string;
  showBlue?: boolean;
  showGreen?: boolean;
  showRed?: boolean;
  helperText?: JSX.Element | string | undefined;
  error?: boolean;
  color?:
    | 'error'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | undefined;
  isUpdating?: boolean;
  onChange: (value: any, keyboardInputValue?: string | undefined) => void;
  onDateSelected?: (e?: any) => void;
  onKeyDown?: () => void;
  onBlur?: (e?: any) => void;
  name?: string;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
  innerRef?: any;
}

export const MuiDatePicker = (props: MuiDateProps) => {
  const {
    name,
    label,
    color,
    onChange,
    value,
    onKeyDown,
    required,
    minDate,
    maxDate,
    error,
    helperText,
    disabled,
    innerRef,
    onBlur,
    isUpdating,
    onDateSelected,
  } = props;
  const [open, setOpen] = useState(false);

  return (
    <div>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        dateFormats={{
          fullDate: 'YYYY-MM-DD',
        }}
      >
        <DesktopDatePicker
          mask="__/__/____"
          inputFormat="DD/MM/YYYY"
          disabled={disabled}
          maxDate={maxDate}
          minDate={minDate}
          className="date-picker"
          open={open}
          onClose={() => setOpen(() => false)}
          onAccept={onDateSelected}
          renderInput={(propsDate) => (
            <TextField
              {...propsDate}
              required={required}
              autoComplete="false"
              ref={innerRef}
              variant="filled"
              onKeyDown={onKeyDown}
              onBlur={onBlur}
              label={label}
              className="w-full "
              color={!disabled ? color : 'warning'}
              name={name}
              error={error}
              helperText={helperText}
              InputProps={{
                disableUnderline: true,
                placeholder: 'DD/MM/YYYY',
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className="px-1"
                    disablePointerEvents={disabled}
                  >
                    {!false && (
                      <img
                        onClick={() => setOpen((prev) => !prev)}
                        src={newCalenderImage}
                        aria-hidden
                        alt="calender"
                        className="calender-cursor"
                      />
                    )}
                    {isUpdating && (
                      <i>
                        <img
                          src={SpinnerLoader}
                          alt="spinner"
                          className="spinner"
                        />
                      </i>
                    )}
                  </InputAdornment>
                ),
              }}
            />
          )}
          onChange={onChange}
          value={value}
        />
      </LocalizationProvider>
    </div>
  );
};

MuiDatePicker.defaultProps = {
  placeHolder: '',
  testId: '',
  label: '',
  value: null,
  color: 'info',
  error: false,
  helperText: undefined,
  showBlue: false,
  showGreen: false,
  showRed: false,
  isUpdating: false,
  onKeyDown: () => ({}),
  onBlur: () => ({}),
  name: '',
  disabled: false,
  innerRef: null,
};

export default MuiDatePicker;
